import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import Dashboard from "../Dashboard";

function AdminDashboard(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={11}
        childrenPage={<Dashboard/>}/>
        </DataContext.Provider>
    )
}

export default AdminDashboard;